export default {
  REGION_FILTER_CODES: [
    'au',
    'be',
    'ca',
    'ch',
    'de',
    'dk',
    'es',
    'fi',
    'fr',
    'hk',
    'ie',
    'it',
    'jp',
    'lu',
    'mx',
    'nl',
    'no',
    'nz',
    'pt',
    'ru',
    'se',
    'uk',
  ],
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/reverb-js-common/constants.js